import * as C from '../constants';
import * as api from '../api';
import { createAction } from 'redux-actions';

export const updateBuyShopItemState = createAction(
  C.ACTION_TYPES.SHOP_ITEM_BUY_UPDATE_STATE,
  (nextState: C.BUY_SHOP_ITEM_STATE) => ({ nextState })
);

export const actionAddBuyShopItem = createAction(
  C.ACTION_TYPES.SHOP_ITEM_ADD,
  (shopItem: ShopItem) => ({ shopItem })
);

export const selectShopItem = (shopItemId: number): ShopItemSelect => ({
  type: C.ACTION_TYPES.SHOP_ITEM_SELECT,
  payload: {
    shopItemId,
  },
});

export const resetBuyShopItemState = () =>
  updateBuyShopItemState(C.BUY_SHOP_ITEM_STATE.DEFAULT);

export const setFetchingBuyShopItemState = () =>
  updateBuyShopItemState(C.BUY_SHOP_ITEM_STATE.FETCHING);

function handle412(response, dispatch) {
  return response
    .json()
    .then((json: ErrorResponse) => {
      if (C.BUY_SHOP_ITEM_STATE.hasOwnProperty(json.error_code)) {
        return dispatch(
          updateBuyShopItemState(C.BUY_SHOP_ITEM_STATE[json.error_code])
        );
      } else {
        return dispatch(
          updateBuyShopItemState(C.BUY_SHOP_ITEM_STATE.SERVER_ERROR)
        );
      }
    })
    .catch(e =>
      dispatch(updateBuyShopItemState(C.BUY_SHOP_ITEM_STATE.SERVER_ERROR))
    );
}

// not used but still keep because user is redirected to web.sourcesage.co
export const buyChannelShopItem = (
  channelId: number,
  shopItemId: number
) => async (dispatch: any, getState: any) => {
  // Reset buy shop item state.
  dispatch(setFetchingBuyShopItemState());
  dispatch(selectShopItem(shopItemId));
  try {
    const r = await api.shop.buyShopItem(channelId, shopItemId);
    switch (r.status) {
      case 200:
        return r.json().then(json => {
          dispatch(actionAddBuyShopItem(json));
          dispatch(updateBuyShopItemState(C.BUY_SHOP_ITEM_STATE.SUCCESS));
        });
      case 404:
        return dispatch(
          updateBuyShopItemState(C.BUY_SHOP_ITEM_STATE.NOT_EXISTS)
        );
      case 412:
        return handle412(r, dispatch);
      case 500:
        return dispatch(
          updateBuyShopItemState(C.BUY_SHOP_ITEM_STATE.SERVER_ERROR)
        );
    }
  } catch (e) {
    dispatch(updateBuyShopItemState(C.BUY_SHOP_ITEM_STATE.CLIENT_ERROR));
  }
};

export const topUpGoldAccountThenBuy = (shopItem: ShopItem) => async (
  dispatch: any,
  getState: any
) => {
  dispatch(setFetchingBuyShopItemState());
  try {
    const r = await api.shop.topUpGoldAccount(shopItem);
    switch (r.status) {
      case 200:
        return dispatch(buyChannelShopItem(shopItem.channel.id, shopItem.id));
      case 412:
        return handle412(r, dispatch);
      case 500:
        return dispatch(
          updateBuyShopItemState(C.BUY_SHOP_ITEM_STATE.SERVER_ERROR)
        );
    }
  } catch (e) {
    dispatch(updateBuyShopItemState(C.BUY_SHOP_ITEM_STATE.CLIENT_ERROR));
  }
};



// WEBPACK FOOTER //
// ./app/actions/ShopActionCreators.ts